import { Controller } from "@hotwired/stimulus"
import { logger } from "../logger"

// Connects to data-controller="column-library-collapse"
// Manages collapse/expand state for the column library panel in report designer v3
export default class extends Controller {
  static targets = ["toggleIcon"]
  static values = { collapsed: Boolean }

  connect() {
    logger.log("[Column Library Collapse] Controller connected")
    this.updateToggleIcon()
  }

  // Toggle panel collapsed/expanded state
  toggle(event) {
    logger.log("[Column Library Collapse] Toggle clicked", {
      currentCollapsed: this.collapsedValue,
      element: this.element
    })
    event?.preventDefault()
    this.collapsedValue = !this.collapsedValue
    this.element.classList.toggle('collapsed')

    // Also toggle the class on the center panel so it can expand
    const centerPanel = this.element.parentElement.querySelector('.panel-center')
    if (centerPanel) {
      centerPanel.classList.toggle('column-library-collapsed')
    }

    logger.log("[Column Library Collapse] After toggle", {
      newCollapsed: this.collapsedValue,
      hasCollapsedClass: this.element.classList.contains('collapsed'),
      centerPanelHasClass: centerPanel?.classList.contains('column-library-collapsed')
    })
    this.updateToggleIcon()
  }

  // Update toggle icon direction
  updateToggleIcon() {
    if (!this.hasToggleIconTarget) return

    const icon = this.toggleIconTarget
    const isRTL = document.dir === 'rtl' ||
                  document.documentElement.dir === 'rtl' ||
                  document.body.dir === 'rtl' ||
                  getComputedStyle(document.body).direction === 'rtl'

    if (this.collapsedValue) {
      // When collapsed, arrow points toward content (to expand)
      // LTR: panel on left, points right →
      // RTL: panel on right, points left ←
      icon.className = isRTL ? 'fas fa-chevron-left' : 'fas fa-chevron-right'
    } else {
      // When expanded, arrow points into panel (to collapse)
      // LTR: panel on left, points left ←
      // RTL: panel on right, points right →
      icon.className = isRTL ? 'fas fa-chevron-right' : 'fas fa-chevron-left'
    }
  }

  // Stimulus lifecycle: when collapsed value changes
  collapsedValueChanged() {
    this.updateToggleIcon()
  }
}
